export const khugaNFTs = [
        {
            id: 'Khuga by Khuga Labs-5533',
            name: 'Khuga #5533',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5533.png',
            price: '0.15 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5554',
            name: 'Khuga #5554',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5554.png',
            price: '0.28 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5543',
            name: 'Khuga #5543',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5543.png',
            price: '0.42 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5536',
            name: 'Khuga #5536',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5536.png',
            price: '0.35 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5531',
            name: 'Khuga #5531',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5531.png',
            price: '0.12 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5521',
            name: 'Khuga #5521',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5521.png',
            price: '0.21 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5534',
            name: 'Khuga #5534',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5534.png',
            price: '0.45 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5523',
            name: 'Khuga #5523',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5523.png',
            price: '0.18 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5516',
            name: 'Khuga #5516',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5516.png',
            price: '0.32 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5552',
            name: 'Khuga #5552',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5552.png',
            price: '0.25 ETH'
        },
            {
            id: 'Khuga by Khuga Labs-5518',
            name: 'Khuga #5518',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5518.png',
            price: '0.38 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5538',
            name: 'Khuga #5538',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5538.png',
            price: '0.15 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5548',
            name: 'Khuga #5548',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5548.png',
            price: '0.28 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5508',
            name: 'Khuga #5508',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5508.png',
            price: '0.42 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5551',
            name: 'Khuga #5551',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5551.png',
            price: '0.35 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5546',
            name: 'Khuga #5546',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5546.png',
            price: '0.12 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5527',
            name: 'Khuga #5527',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5527.png',
            price: '0.21 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5540',
            name: 'Khuga #5540',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5540.png',
            price: '0.45 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5525',
            name: 'Khuga #5525',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5525.png',
            price: '0.18 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5544',
            name: 'Khuga #5544',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5544.png',
            price: '0.32 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5512',
            name: 'Khuga #5512',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5512.png',
            price: '0.25 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5510',
            name: 'Khuga #5510',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5510.png',
            price: '0.38 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5507',
            name: 'Khuga #5507',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5507.png',
            price: '0.15 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5514',
            name: 'Khuga #5514',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5514.png',
            price: '0.28 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5529',
            name: 'Khuga #5529',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5529.png',
            price: '0.42 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5532',
            name: 'Khuga #5532',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5532.png',
            price: '0.35 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5555',
            name: 'Khuga #5555',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5555.png',
            price: '0.12 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5542',
            name: 'Khuga #5542',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5542.png',
            price: '0.21 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5535',
            name: 'Khuga #5535',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5535.png',
            price: '0.45 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5537',
            name: 'Khuga #5537',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5537.png',
            price: '0.18 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5553',
            name: 'Khuga #5553',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5553.png',
            price: '0.32 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5539',
            name: 'Khuga #5539',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5539.png',
            price: '0.25 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5520',
            name: 'Khuga #5520',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5520.png',
            price: '0.38 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5530',
            name: 'Khuga #5530',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5530.png',
            price: '0.15 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5549',
            name: 'Khuga #5549',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5549.png',
            price: '0.28 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5550',
            name: 'Khuga #5550',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5550.png',
            price: '0.42 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5545',
            name: 'Khuga #5545',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5545.png',
            price: '0.35 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5541',
            name: 'Khuga #5541',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5541.png',
            price: '0.12 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5519',
            name: 'Khuga #5519',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5519.png',
            price: '0.21 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5547',
            name: 'Khuga #5547',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5547.png',
            price: '0.45 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5522',
            name: 'Khuga #5522',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5522.png',
            price: '0.18 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5524',
            name: 'Khuga #5524',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5524.png',
            price: '0.32 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5517',
            name: 'Khuga #5517',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5517.png',
            price: '0.25 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5526',
            name: 'Khuga #5526',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5526.png',
            price: '0.38 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5528',
            name: 'Khuga #5528',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5528.png',
            price: '0.15 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5511',
            name: 'Khuga #5511',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5511.png',
            price: '0.28 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5515',
            name: 'Khuga #5515',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5515.png',
            price: '0.42 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5506',
            name: 'Khuga #5506',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5506.png',
            price: '0.35 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5509',
            name: 'Khuga #5509',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5509.png',
            price: '0.12 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5513',
            name: 'Khuga #5513',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5513.png',
            price: '0.21 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5494',
            name: 'Khuga #5494',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5494.png',
            price: '0.45 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5043',
            name: 'Khuga #5043',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5043.png',
            price: '0.18 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5495',
            name: 'Khuga #5495',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5495.png',
            price: '0.32 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5477',
            name: 'Khuga #5477',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5477.png',
            price: '0.25 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5044',
            name: 'Khuga #5044',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5044.png',
            price: '0.38 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5484',
            name: 'Khuga #5484',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5484.png',
            price: '0.15 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5504',
            name: 'Khuga #5504',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5504.png',
            price: '0.28 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5499',
            name: 'Khuga #5499',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5499.png',
            price: '0.42 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5465',
            name: 'Khuga #5465',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5465.png',
            price: '0.35 ETH'
        },
            {
            id: 'Khuga by Khuga Labs-5500',
            name: 'Khuga #5500',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5500.png',
            price: '0.12 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5467',
            name: 'Khuga #5467',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5467.png',
            price: '0.21 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5483',
            name: 'Khuga #5483',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5483.png',
            price: '0.45 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5473',
            name: 'Khuga #5473',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5473.png',
            price: '0.18 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5497',
            name: 'Khuga #5497',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5497.png',
            price: '0.32 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5460',
            name: 'Khuga #5460',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5460.png',
            price: '0.25 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5505',
            name: 'Khuga #5505',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5505.png',
            price: '0.38 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5485',
            name: 'Khuga #5485',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5485.png',
            price: '0.15 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5498',
            name: 'Khuga #5498',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5498.png',
            price: '0.28 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5492',
            name: 'Khuga #5492',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5492.png',
            price: '0.42 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5490',
            name: 'Khuga #5490',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5490.png',
            price: '0.35 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5481',
            name: 'Khuga #5481',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5481.png',
            price: '0.12 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5476',
            name: 'Khuga #5476',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5476.png',
            price: '0.21 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5464',
            name: 'Khuga #5464',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5464.png',
            price: '0.45 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5475',
            name: 'Khuga #5475',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5475.png',
            price: '0.18 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5470',
            name: 'Khuga #5470',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5470.png',
            price: '0.32 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5501',
            name: 'Khuga #5501',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5501.png',
            price: '0.25 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5489',
            name: 'Khuga #5489',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5489.png',
            price: '0.38 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5482',
            name: 'Khuga #5482',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5482.png',
            price: '0.15 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5472',
            name: 'Khuga #5472',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5472.png',
            price: '0.28 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5248',
            name: 'Khuga #5248',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5248.png',
            price: '0.42 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5461',
            name: 'Khuga #5461',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5461.png',
            price: '0.35 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5466',
            name: 'Khuga #5466',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5466.png',
            price: '0.12 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5496',
            name: 'Khuga #5496',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5496.png',
            price: '0.21 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5486',
            name: 'Khuga #5486',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5486.png',
            price: '0.45 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5469',
            name: 'Khuga #5469',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5469.png',
            price: '0.18 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5479',
            name: 'Khuga #5479',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5479.png',
            price: '0.32 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5431',
            name: 'Khuga #5431',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5431.png',
            price: '0.25 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5429',
            name: 'Khuga #5429',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5429.png',
            price: '0.38 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5480',
            name: 'Khuga #5480',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5480.png',
            price: '0.15 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5493',
            name: 'Khuga #5493',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5493.png',
            price: '0.28 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5471',
            name: 'Khuga #5471',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5471.png',
            price: '0.42 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5491',
            name: 'Khuga #5491',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5491.png',
            price: '0.35 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5438',
            name: 'Khuga #5438',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5438.png',
            price: '0.12 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5488',
            name: 'Khuga #5488',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5488.png',
            price: '0.21 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5474',
            name: 'Khuga #5474',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5474.png',
            price: '0.45 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5440',
            name: 'Khuga #5440',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5440.png',
            price: '0.18 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5457',
            name: 'Khuga #5457',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5457.png',
            price: '0.32 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5463',
            name: 'Khuga #5463',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5463.png',
            price: '0.25 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5436',
            name: 'Khuga #5436',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5436.png',
            price: '0.38 ETH'
        },
        {
            id: 'Khuga by Khuga Labs-5459',
            name: 'Khuga #5459',
            image: 'https://ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/5459.png',
            price: '0.15 ETH'
        }
    
];